import { Input } from "antd";
import Title from "antd/es/typography/Title";
import { InformationFormData } from "components/Forms/ApiToolGeneralForm/formSchema";
import { useGeneralForm } from "components/UI/GeneralForm/hooks/useGeneralForm";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { FormItem } from "react-hook-form-antd";


export const InformationSection: FC = () => {
    const { t } = usePaldockTranslation("forms.connection-creator-information");
    const { t: tFields } = usePaldockTranslation("forms.general-fields");
    const generalFormUtils = useGeneralForm<InformationFormData>();
    const { control, fieldNames } = generalFormUtils;

    return (
        <>
            <Title level={3} className="mb-6">
                {t("sections.information.title")}
            </Title>
            <FormItem control={control} name={fieldNames.description?.name || "description"}>
                <Input.TextArea placeholder={tFields("description.placeholder")} rows={10} />
            </FormItem>
        </>
    );
};
